/**
 * One source of truth for "can this user delegate tasks right now?" — used to gate every task-creation
 * control (floating button, contextual buttons, panel). Controls render visible-but-disabled with an
 * explanation when the platform isn't write-enabled yet, rather than hiding (matches the /tasks banner).
 */
import { useQuery } from '@tanstack/react-query';
import { getMe, getTaskPlatformStatus, type MeResponse } from './api';

export const TASK_DISABLED_TITLE =
  '任务系统未配置 — 待管理员（邹兴兵）开通后即可派发 / Task delegation activates once the admin enables the task API';

export function useTaskConfigured() {
  const { data: me } = useQuery<MeResponse>({ queryKey: ['me'], queryFn: getMe });
  const isInternal = me?.account?.subject_type === 'staff';
  const status = useQuery({ queryKey: ['task-status'], queryFn: getTaskPlatformStatus, enabled: isInternal });
  return { isInternal: !!isInternal, configured: !!status.data?.configured, role: me?.account?.role ?? null };
}
